<template>
    <div>
      <lot-alien-details v-if="lot" :lot="lot" :bidId="bidId" historical></lot-alien-details>
      <loading v-if="loading"></loading>
    </div>
</template>

<script>
  import LotAlienDetails from './AlienDetails'

  export default {
    components: {
      LotAlienDetails
    },

    computed: {
      lotId() {
        return +this.$route.params.lotId;
      },

      requestId() {
        return +this.$route.params.requestId;
      },

      historyId() {
        return +this.$route.params.historyId;
      },

      bidId() {
        return +this.$route.params.bidId;
      },

      tab() {
        return this.$route.params.tab;
      },

      lot() {
        let lot = this.$store.getters.otherRequest(this.lotId, this.requestId, this.historyId);
        return lot;
      }
    },

    beforeRouteEnter(to, from, next) {
      next(async vm =>  {
        await vm.loadRequest();
      });
    },

    methods: {
      loadRequest() {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchRequestWithHistory', {
              lotId: this.lotId,
              requestId: this.requestId,
              historyId: this.historyId,
              bidId: this.bidId
            });
          }
          catch(e) {
            console.error('failed fetching alien request', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
